import { queryOptions } from "@tanstack/react-query";

import { getUserWithCompanyRelation } from "@/generated/api/users";

const userQuery = ({ id }: { id: number }) =>
  queryOptions({
    queryFn: ({ signal }) => getUserWithCompanyRelation(id, { signal }),
    queryKey: ["user", id],
  });

export { userQuery };
